export default function ($translate) {
    return {
        KEYS: {
            NOT_STARTED: 'NOT_STARTED',
            FILL_EMPLOYEE: 'FILL_EMPLOYEE',
            FILL_MANAGER: 'FILL_MANAGER',
            CONFIRM_EMPLOYEE: 'CONFIRM_EMPLOYEE',
            CONFIRMED: 'CONFIRMED',
            ARCHIVED: 'ARCHIVED'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('performanceReview.Not started'),
            FILL_EMPLOYEE: $translate.instant('performanceReview.Fill employee'),
            FILL_MANAGER: $translate.instant('performanceReview.Fill manager'),
            CONFIRM_EMPLOYEE: $translate.instant('performanceReview.Confirm employee'),
            CONFIRMED: $translate.instant('performanceReview.Confirmed'),
            ARCHIVED: $translate.instant('performanceReview.Archived')
        },
        KEY_LABEL_PAIRS: [
            {
                KEY: 'NOT_STARTED',
                LABEL: $translate.instant('performanceReview.Not started')
            },
            {
                KEY: 'FILL_EMPLOYEE',
                LABEL: $translate.instant('performanceReview.Fill employee')
            },
            {
                KEY: 'FILL_MANAGER',
                LABEL: $translate.instant('performanceReview.Fill manager')
            },
            {
                KEY: 'CONFIRM_EMPLOYEE',
                LABEL: $translate.instant('performanceReview.Confirm employee')
            },
            {
                KEY: 'CONFIRMED',
                LABEL: $translate.instant('performanceReview.Confirmed')
            },
            {
                KEY: 'ARCHIVED',
                LABEL: $translate.instant('performanceReview.Archived')
            }
        ]
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/review/status/index.js